export const environment = {
  production: false, 
  showLogs: true,
  region: 'ap-southeast-1', 
  bucketName: 'ecaas-files-qa',
  cognitoIdentityEndpoint: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_5KfgWKOL4',
  appName: 'Swift Rewards',
  otp: {
    requestOtp: true,
    defaultOtp: '123456',
    skipRequestSchemas: ['00', '02', '11', '12', '13', '14', '15', '16', '18', '21', '23', '24', '29', '31', '32', '33', '41', '42', '43', '44', '46']
  },
  webCustomerUrl: 'https://qa2.swift-rewards.com',
  auth: {
    identityPoolId: 'ap-southeast-1:7dbb3b68-88cf-404c-b6c6-2037a5f97d15',
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_5KfgWKOL4',
    userPoolWebClientId: 'hipd91k4nnkl0lrhq64eus47r',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  api: {
    endpoints: [
      {
        name: "SwiftRewardsApi",
        endpoint: "https://swiftrewardsqa-green-api.escienceapps.com"
      }
    ]
  },
};